import { C, Badge, Card } from './shared';

export default function RoadmapTab() {
  const phases = [
    { name: 'Phase A — Foundation', color: C.green, status: 'COMPLETE',
      sessions: ['S1-14', 'S19', 'S20-20B', 'S21', 'S22A', 'S22B', 'S22C'],
      goal: 'Build the platform before monetisation',
      summary: 'Full platform live: auth, AI analysis (BULLISH/NEUTRAL/BEARISH), 229 SEO stock pages, caching, watchlist + GDPR digest, market dashboard, stock page depth, historical calculator with DRIP.' },
    { name: 'Phase B — Virality + Retention + Trading Intelligence', color: C.warning, status: 'IN PROGRESS',
      sessions: ['S27A', 'S27B', 'S27C', 'S27D', 'S27E', 'S27F', 'S27G', 'S27H', 'S27-ALGO', 'S27-ALGO-V3', 'S27H-UI', 'S27-CHART-ENGINE', 'S27I', 'S27J', 'S27K', 'S27N', 'S27-MARKET-A', 'S27-MARKET-B', 'S27-MARKET-C', 'ADMIN-PORTAL'],
      goal: 'Get users to share + return daily. Chart becomes D3 signal engine.',
      summary: 'S27A-G ✅ → S27-CHART-ENGINE ✅ (a31cf53) → S27I ✅ Drawing System V2 (b769572) → S27J ✅ Screener Phase 2 (5486c1f) → S27K NEXT: Analyst Ratings + Price Alerts → ADMIN-PORTAL planned: admin.marketpulze.com + Stripe billing (Phase C trigger).' },
    { name: 'Phase C — Depth', color: C.info, status: 'PLANNED',
      sessions: ['S28A', 'S28B', 'S28C', 'S28D'],
      goal: 'Become research-grade — beat paid competitors on depth',
      summary: 'S28A Intelligence+Alerts → S28B Extended Depth A (Analyst/Peers/Dividends) → S28C Depth B+Smart Money → S28D AI Scorecard: 8-dimension SEC EDGAR scoring — our unique differentiator.' },
    { name: 'Phase D — Zenith + IBKR', color: C.purple, status: 'FUTURE',
      sessions: ['D3-AUTH', 'D3-PORTAL', 'OCI-DR', 'D0', 'D3'],
      goal: 'Personal trading suite + automated IBKR execution',
      summary: 'D3-AUTH: signalWriter + Google OAuth + TOTP + inner circle access. D3-PORTAL: trading.marketpulze.com D3 control panel (after OCI-8). OCI-DR: backup + Frankfurt DR (before D3c live capital). D3: Claude AI capital gate + IBKR live execution.' },
  ];
  return (
    <div style={{ display: 'grid', gap: 14 }}>
      {phases.map(p => (
        <div key={p.name} style={{ background: C.card, borderRadius: 10, padding: 20,
          borderLeft: '4px solid ' + p.color, border: '1px solid ' + p.color + '33' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <div>
              <div style={{ color: p.color, fontWeight: 800, fontSize: 16 }}>{p.name}</div>
              <div style={{ color: C.muted, fontSize: 12, marginTop: 3 }}>{p.goal}</div>
            </div>
            <Badge color={p.color}>{p.status}</Badge>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
            {p.sessions.map(s => (
              <span key={s} style={{ background: p.color + '22', color: p.color,
                borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 700 }}>{s}</span>
            ))}
          </div>
          <div style={{ color: C.subtle, fontSize: 13, lineHeight: 1.7 }}>{p.summary}</div>
        </div>
      ))}

      {/* D3 Chart Roadmap — separate card */}
      <Card title="D3 Chart Engineering Roadmap" accent={C.purple}>
        <div style={{ color: C.muted, fontSize: 11, marginBottom: 12 }}>
          Every chart indicator a member toggles = D3 strategy fingerprint. No vendor sells this.
        </div>
        {[
          { session: 'S27E ✅', what: 'Candlestick + Volume + ChartInteractionLog', d3: 'Timeframe dist → trader style. Hover price → crowd S/R.', color: C.green },
          { session: 'S27F ✅', what: 'SMA 20/50/200 + RSI(14) sub-panel', d3: 'SMA crossover → technical analysis preference. RSI level monitoring.', color: C.green },
          { session: 'S27G ✅', what: 'Trendlines + Horizontal Levels + DrawingLog', d3: 'Member-drawn S/R → crowd-validated price levels. Drawing persistence.', color: C.green },
          { session: 'S27H ✅', what: '/chart/:ticker full page + BB + MACD + VWAP + EMA + Stoch + 5 Templates + IndicatorLayout', d3: 'Template loads → strategy declaration. Custom periods → unique fingerprint. ScanContext → strategy chain.', color: C.green },
          { session: 'S27H-UI ✅', what: 'Floating pill bar + collapsible sidebar + MarketPulze branding + D3 perf log', d3: 'pill_set_at_conviction → L2 context. sidebar_state → sophistication proxy. performance_view → conviction correlation.', color: C.green },
          { session: 'S27-CHART-ENGINE ✅', what: 'Pure D3.js engine — 16 indicators, 6 chart types, multi-instance + color picker, apiFetch 24/7 auth (a31cf53)', d3: 'chart_type_change → L2 strategy fingerprint. indicator_add combinationHash → strategy_classification. Renko = price action purist.', color: C.green },
          { session: 'S27I NEXT', what: 'Fibonacci + Drawing V2 + Scanner-Chart Signal Chain', d3: 'Fib levels from multiple members = institutional S/R. Scan→draw chain = highest-confidence signal.', color: C.info },
          { session: 'OCI-4 PLANNED', what: 'Full OHLCV history from OCI ATP (Stooq bulk)', d3: 'Eliminates Marketstack. 30yr history for D3 backtesting.', color: C.info },
        ].map(r => (
          <div key={r.session} style={{ display: 'grid', gridTemplateColumns: '120px 2fr 2fr',
            gap: 10, padding: '8px 0', borderBottom: '1px solid ' + C.border + '22', alignItems: 'start' }}>
            <Badge color={r.color}>{r.session}</Badge>
            <span style={{ color: C.text, fontSize: 12, fontWeight: 600 }}>{r.what}</span>
            <span style={{ color: C.muted, fontSize: 11 }}>{r.d3}</span>
          </div>
        ))}
      </Card>
    </div>
  );
}

// ── TAB 5: Feature Requests ───────────────────────────────────────────────────
// Shows: (1) Rule 11 process reminder  (2) New feature capture form
//        (3) Planned + Future backlog  (4) Completed sessions — reconciliation view
// The completed section reconciles what's built vs what's in backlog.
